import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import { brandIvory, brandOrange } from '../../../assets/consts/color'

export const CopyWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px;
  display: grid;
  gap: 12px;
  margin: 0;
  background-color: ${brandIvory};

  h5 {
    font-weight: bold;
    color: ${brandOrange};
  }

  p {
    margin: 0;
  }
`

function SummaryCard({ title = '', content = '' }) {
  return (
    <CopyWrapper>
      <TypographyAtom type="H5" copy={title} />
      {content.raw ? (
        <TypographyAtom type="BlockText" copyBlock={content} weight="BlockText" />
      ) : (
        <TypographyAtom type="P" weight="Regular" copy={content} />
      )}
    </CopyWrapper>
  )
}

export default SummaryCard
